export default class LinkPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, parentType, parent) {
        return this.gate.allow('read', parentType, parent);
    }

    add(user, parentType, parent) {
        return this.gate.allow('edit', parentType, parent);
    }

    edit(user, link, parentType, parent) {
        return this.gate.allow('edit', parentType, parent);
    }

    destroy(user, link, parentType, parent) {
        return this.gate.allow('edit', parentType, parent);
    }

    sort(user, link, parentType, parent) {
        return this.gate.allow('edit', parentType, parent);
    }

    updateSortIndex(user, link, parentType, parent, destination) {
        if (!this.sort(user, link, parentType, parent)) {
            return false;
        }

        if (!destination) {
            return false;
        }

        return link.sort_index !== Number(destination);
    }
}
